<h2 mat-dialog-title>Segnala un problema</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Descrizione del problema</mat-label>
      <textarea matInput formControlName="descrizione" rows="5"
        placeholder="Descrivi il problema riscontrato..."></textarea>
    </mat-form-field>
  </form>

  <div class="file-upload-section">
    <button mat-stroked-button type="button" (click)="fileInput.click()">
      <mat-icon>photo_camera</mat-icon> Allega foto
    </button>
    <input #fileInput type="file" hidden multiple accept="image/*" (change)="onFilesSelected($event)" />
    <div *ngIf="files.length" class="file-list" style="margin-top: 8px;">
      <div *ngFor="let file of files; let i = index" style="display: flex; align-items: center; gap: 4px; margin-bottom: 4px;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">image</mat-icon>
        <span style="font-size: 13px; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ file.name }}</span>
        <button mat-icon-button type="button" (click)="removeFile(i)" style="width: 28px; height: 28px; line-height: 28px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">close</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annulla</button>
  <button mat-raised-button color="primary" [disabled]="form?.invalid" (click)="submit()">Invia</button>
</mat-dialog-actions>
